module.exports = __webpack_public_path__ + "static/media/resume.78781bbb.pdf";